import { createApi } from "@reduxjs/toolkit/query/react";

import { ENV_CONFIG } from "../../config/global.config";
import { ORDER_API_TAGS } from "../app.constants";
import { baseQueryWithReauth } from "./baseQuery";

// --- API ---

export const orderServiceApi = createApi({
  reducerPath: "orderServiceApi",
  baseQuery: baseQueryWithReauth(ENV_CONFIG.ORDER_API_URL),

  tagTypes: Object.values(ORDER_API_TAGS),
  keepUnusedDataFor: 10,
  endpoints: () => ({}),
});
